import { render, staticRenderFns } from "./ProductResources.vue?vue&type=template&id=b453f448"
import script from "./ProductResources.vue?vue&type=script&lang=js"
export * from "./ProductResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports